<!--
  订单详情
  Lovi 2020-06-23
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('life.orderDetail')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll v-if="productInfo.length">
        <div class="order-detail">
          <div
            class="notice order-column"
            v-if="detail.status == 0 && noticeFlag"
          >
            <van-icon name="volume-o" class="text-blue" />
            <span class="text-hidden">
              {{ $t("life.noPayTips") }}
            </span>
            <van-icon name="cross" @click="noticeFlag = false" />
          </div>
          <!-- 产品信息 -->
          <div class="order-column">
            <div class="title">
              <h3>{{ detail.shop_name }}</h3>
              <status
                :data="detail"
                :evaluateFlag.sync="evaluateFlag"
                :evaluateData.sync="evaluateData"
                @request="getOrderdetail"
              />
            </div>
            <div class="content">
              <div class="pro-wrap" :class="{ allPro: allProFlag }">
                <div
                  class="pro-item"
                  v-for="(item, index) in productInfo"
                  :key="index"
                >
                  <div class="image">
                    <img :src="httpUrl + item.image" />
                  </div>
                  <div class="info">
                    <div class="name-price">
                      <h3>{{ item.product_name }}</h3>
                      <div class="price">
                        <span
                          v-if="Number(item.original_price)"
                          class="original_price text-gray"
                        >
                          {{ item.original_price }}P
                        </span>
                        <span class="text-red">{{ item.selling_price }}P</span>
                      </div>
                    </div>
                    <p>X{{ item.count }}</p>
                  </div>
                </div>
              </div>
              <div
                class="more-pro"
                v-if="moreProFlag"
                @click="allProFlag = !allProFlag"
              >
                {{ allProFlag ? $t("life.fold") : $t("life.unfold") }}
                ({{ $t("shopCart.gong") }}
                {{ productInfo.length }}
                {{ $t("shopCart.items") }})
                <van-icon :class="{ rotate: allProFlag }" name="arrow-down" />
              </div>

              <div class="van-cell-wrap">
                <van-cell
                  :title="$t('life.deliveryFee')"
                  :value="detail.delivery_fee + 'P'"
                />
                <van-cell
                  :title="$t('life.packingFee')"
                  :value="detail.packaging_fee + 'P'"
                />
                <van-cell :title="$t('coupon.goodsCashback')">
                  <span
                    slot="default"
                    :class="{ 'text-red': detail.full_reduction }"
                  >
                    {{
                      detail.full_reduction ? detail.full_reduction + "P" : 0
                    }}
                  </span>
                </van-cell>
                <van-cell :title="$t('coupon.coupon')">
                  <span
                    slot="default"
                    :class="{ 'text-red': detail.coupon_discount }"
                  >
                    {{
                      detail.coupon_discount
                        ? detail.coupon_discount + "P"
                        : $t("common.nothing")
                    }}
                  </span>
                </van-cell>
              </div>
              <div class="price-total">
                <span>
                  {{ $t("life.discounted") }}
                  <i class="text-red">{{ detail.favoured_price }}P</i>
                </span>
                <span>
                  {{ $t("life.total") }}
                  <i class="text-red total">{{ detail.total_price }}P</i>
                </span>
              </div>
            </div>
          </div>
          <!-- 配送信息 -->
          <div class="order-column ship-info">
            <div class="title">
              <h3>{{ $t("life.shippingInfo") }}</h3>
            </div>
            <div class="content van-cell-wrap">
              <van-cell :title="$t('life.shippingAddress')">
                <template slot="default">
                  <h3>{{ addressInfo.address }}</h3>
                  <p>
                    {{ addressInfo.name }}
                    <!-- ({{ ship_info.sex == 1 ? "先生" : "女士" }}) -->
                    {{ addressInfo.phone }}
                  </p>
                </template>
              </van-cell>
              <van-cell
                :title="$t('life.deliveryMethod')"
                :value="addressInfo.delivery_way"
              />
              <van-cell
                v-if="detail.status == 3 || detail.status == 4"
                :title="$t('life.deliveryman')"
                :value="detail.delivery_name + detail.delivery_phone"
              />
            </div>
          </div>
          <!-- 订单信息 -->
          <div class="order-column order-info">
            <div class="title">
              <h3>{{ $t("life.orderInfo") }}</h3>
            </div>
            <div class="content van-cell-wrap">
              <van-cell
                :title="$t('life.orderNumber')"
                :value="orderInfo.order_sn"
              />
              <van-cell
                :title="$t('life.orderTime')"
                :value="orderInfo.createtime"
              />
              <van-cell
                :title="$t('life.termsPayment')"
                :value="orderInfo.payment"
              />
              <van-cell
                :title="$t('life.orderNote')"
                :value="
                  orderInfo.remarks ? orderInfo.remarks : $t('common.nothing')
                "
              />
            </div>
          </div>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <evaluate
        v-if="evaluateFlag"
        :evaluateFlag.sync="evaluateFlag"
        :data="evaluateData"
        @getEvaluate="getOrderdetail"
      />
    </transition>
  </div>
</template>

<script>
import Evaluate from "./evaluate";
import Status from "./status";
export default {
  name: "orderDetail",
  meta: {
    service: false // 客服
  },
  components: {
    Evaluate,
    Status
  },
  data() {
    return {
      id: "", //订单Id
      noticeFlag: true, // 公告Flag
      allProFlag: false, //所有产品Flag
      moreProFlag: false, //更多产品Flag

      detail: {},
      productInfo: [],
      addressInfo: [],
      orderInfo: [],
      evaluateFlag: false, // 评价
      evaluateData: {}
    };
  },
  created() {
    this.id = this.$route.query.id || "";
    this.getOrderdetail();
  },
  mounted() {},
  computed: {},
  methods: {
    getOrderdetail() {
      let vm = this;
      vm.$post(
        "/app/order/myorderDetail",
        { order_id: vm.id },
        { loading: true }
      ).then(res => {
        console.log("myorderDetail", res);
        vm.detail = res[0];
        vm.productInfo = res[0].product_info;
        if (vm.productInfo.length > 3) {
          vm.moreProFlag = true;
        }
        vm.addressInfo = res[0].address_info[0];
        vm.orderInfo = res[0].order_info[0];
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  background: #f4f4f4;
  .order-detail {
    padding: 1.1px 0;
  }
}
.order-column {
  margin: 10px;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    height: 40px;
    border-bottom: 1.1px solid #e3e3e3;
    h3 {
      font-size: 16px;
      font-weight: 400;
    }
  }
  .content {
    padding: 10px;
  }
}

.ship-info,
.order-info {
  .content {
    padding: 0 10px;
  }
}

.notice {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 10px;
  line-height: 1;
  span {
    flex: 1;
    margin: 0 5px;
  }
  /deep/.van-icon {
    font-size: 16px;
  }
}
.pro-wrap {
  max-height: 200px;
  overflow: hidden;
  &.allPro {
    max-height: initial;
  }
  .pro-item {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    height: 60px;
    &:first-child {
      margin-top: 0;
    }
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .info {
      flex: 1;
      overflow: hidden;
      h3 {
        font-size: 14px;
      }
      p {
        padding-top: 5px;
      }
      .name-price {
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        h3 {
          flex: 1;
          margin-right: 5px;
        }
      }
      .price {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span {
          &.text-red {
            font-size: 15px;
          }
          &.original_price {
            margin-right: 5px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
.more-pro {
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/.van-icon {
    margin-left: 2px;
    font-size: 14px;
    transition: transform 0.5s;
    &.rotate {
      transform: rotate(180deg);
    }
  }
}

.van-cell-wrap {
  /deep/.van-cell {
    padding: 5px 0;
    &::after {
      content: normal;
    }
    .van-cell__title {
      margin-right: 10px;
      flex: initial;
    }
    .van-cell__value {
      h3 {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}

.price-total {
  padding-top: 10px;
  text-align: right;
  font-size: 14px;
  line-height: 1;
  border-top: 1.1px solid #e3e3e3;
  span {
    margin-left: 10px;
  }
  .total {
    font-size: 20px;
  }
}
</style>
